import React, { Component } from 'react';
import './LayerExpPanel.scss';
import {
  getLayerByID,
  updateLayerFromLayerController,
  getLayerSymbology,
  updateSublayerFromLayerController
} from '../../controllers/esriMapController';

import YearSelector from './yearSelector';

import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  hidden: {
    display: 'none'
  },
  expPanel: {
    border: 'none',
    boxShadow: 'none'
  },
  paper: {
    boxShadow: '0px'
  },
  expPanelSummary: {
    alignItems: 'center',
    margin: '0px',
    marginRight: '-12px',
    minHeight: '0px'
  },
  panelLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  expDetails: {
    padding: '0',
    background: '#EFEFEF',
    width: '100%'
  },
  innerPanel: {
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
    padding: '0px 20px',
    margin: '10px'
  },
  innerPanelTopLevel: {
    padding: '0px 10px'
  },
  divider: {
    width: '100%',
    height: '1px',
    border: '.5px solid #D8D8D8',
    marginBottom: '10px'
  },
  labelText: {
    fontSize: theme.typography.pxToRem(12),
    fontFamily: 'Roboto',
    color: theme.palette.primary.darkNeutral,
    fontWeight: 400,
    marginLeft: '4px'
  },
  labelWrapper: {
    wordWrap: 'break-word',
    overflowY: 'hidden',
    textOverflow: 'ellipsis'
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  opacityWrapper: {
    width: '119px',
    marginRight: '8px'
  },
  defaultLegendItems: {
    display: 'flex',
    alignItems: 'center',
    margin: '6px'
  },
  sublayerLegendItems: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    padding: '0px 15px'
  },
  root: {
    boxShadow: '0px',
    width: '100%'
  },
  layerLabel: {
    lineHeight: 'normal',
    color: theme.palette.primary.darkNeutral,
    fontFamily: 'Roboto',
    fontWeight: 300
  },
  layerColor: {
    height: '15px',
    width: '15px',
    borderRadius: '50%',
    display: 'inline-block',
    flexShrink: '0'
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  checkbox: {
    color: '#8c8c8c'
  },
  colorBar: {
    backgroundColor: '#d8d8d8'
  },
  colorChecked: {},
  svg: {
    fill: theme.palette.primary.neutral
  },
  rail: {
    background: '#FFFFFF',
    height: '3px'
  },
  valueLabel: {
    color: '#FFFFFF',
    '& span': {
      '& > :last-child': {
        color: ''
      }
    },
    fontFamily: 'Roboto',
    fontWeight: 400
  },
  tooltip: {
    backgroundColor: theme.palette.secondary.accent,
    color: '#FFFFFF',
    textAlign: 'center',
    height: '10px',
    width: '10px',
    borderRadius: '50%',
    display: 'inline-block',
    position: 'relative',
    flexShrink: '0',
    '&:hover': {
      color: '#F0F8F9',
      '& > :last-child': {
        visibility: 'visible'
      }
    }
  },
  tooltipText: {
    fontSize: '8px'
  },
  tooltipInfo: {
    visibility: 'hidden',
    width: '233px',
    backgroundColor: theme.palette.primary.darkNeutral,
    textAlign: 'center',
    borderRadius: '6px',
    padding: '5px',
    position: 'absolute',
    zIndex: '10',
    top: '18px',
    right: '-40px',
    opacity: '.9'
  },
  tooltipInfoText: {
    fontFamily: 'Roboto',
    fontSize: '12px'
  }
});

export class LayerExpPanel extends Component {
  constructor(props) {
    super(props);

    const layer = getLayerByID(props.layerId);

    this.state = {
      title: layer.title,
      type: layer.type,
      visible: layer.visible,
      sublayers: [],
      opacity: layer.opacity * 100,
      showSlider: false,
      symbology: {},
      layer: layer
    };
  }

  componentDidMount() {
    this.initializeLayer();
  }

  initializeLayer = () => {
    const layer = getLayerByID(this.props.layerId);
    layer.load().then(async () => {
      if (layer.sublayers) {
        const sublayers = layer.sublayers.items.map(sublayer => {
          return {
            visible: sublayer.visible,
            id: sublayer.id
          };
        });
        this.setState({
          sublayers
        });
      }
      const symbology = await getLayerSymbology(this.props.layerId);
      this.setState({
        symbology: symbology
      });
    });
  };

  expandPanel = () => {
    const sliderOn = this.state.showSlider;
    this.setState({ showSlider: !sliderOn });
  };

  handleOpacityChange = (event, value) => {
    const { layerId } = this.props;
    const opacity = value / 100;
    updateLayerFromLayerController('opacity', opacity, layerId);
    this.setState({
      opacity: value
    });
  };

  stopSlider = event => {
    event.stopPropagation();
  };

  handleLayerVisabilityChange = event => {
    updateLayerFromLayerController(
      'visible',
      event.target.checked,
      this.props.layerId
    );

    this.setState({
      visible: event.target.checked
    });
  };

  handleSublayerVisabilityChange = (sublayerID, event) => {
    updateSublayerFromLayerController(
      'visible',
      event.target.checked,
      sublayerID,
      this.props.layerId
    );

    const newState = [];
    this.state.sublayers.forEach(sublayer => {
      const newSubLayer = Object.assign({}, sublayer);
      if (sublayer.id === sublayerID) {
        newSubLayer.visible = event.target.checked;
      }
      newState.push(newSubLayer);
    });
    this.setState({
      sublayers: newState
    });
  };

  generateLegend = legendInfo => {
    const { classes } = this.props;

    switch (this.state.type) {
      case 'imagery':
        return legendInfo.legend.map(legendItem => {
          return (
            <div
              className={classes.defaultLegendItems}
              key={`${legendItem.label}, ${this.state.title}`}
            >
              <div
                className={classes.layerColor}
                style={{
                  backgroundImage: `url(data:image/png;base64,${legendItem.imageData})`,
                  backgroundPosition: 'center'
                }}
              />
              <div className={classes.labelWrapper}>
                <Typography classes={{ root: classes.labelText }}>
                  {legendItem.label}
                </Typography>
              </div>
            </div>
          );
        });
      case 'map-image':
        return legendInfo.map(sublayerInfo => {
          const sublayer = this.state.sublayers.find(
            localSubLayer => localSubLayer.id === sublayerInfo.sublayerID
          );
          return (
            <div
              className={classes.sublayerLegendItems}
              key={sublayerInfo.label}
            >
              {sublayer && (
                <Checkbox
                  checked={sublayer.visible}
                  onChange={event =>
                    this.handleSublayerVisabilityChange(
                      sublayerInfo.sublayerID,
                      event
                    )
                  }
                  classes={{
                    root: classes.checkbox,
                    checked: classes.colorChecked
                  }}
                  color="primary"
                />
              )}
              <div
                className={classes.layerColor}
                style={{ border: `2px solid ${sublayerInfo.color}` }}
              />
              <div>
                <Typography classes={{ root: classes.labelText }}>
                  {sublayerInfo.label}
                </Typography>
              </div>
            </div>
          );
        });
      case 'graphics':
        return;
      default:
        return;
    }
  };

  render() {
    const { classes } = this.props;
    const { expanded } = this.props;

    const innerPanelStyles =
      this.state.layer.id === 'topLevel'
        ? classes.innerPanelTopLevel
        : classes.innerPanel;

    return (
      <div>
        <ExpansionPanel
          classes={{
            root: classes.expPanel,
            expanded: classes.expPanelSummary
          }}
          square={true}
          expanded={expanded}
        >
          <ExpansionPanelSummary
            classes={{
              root: classes.expPanelSummary,
              content: 'custom-content',
              expanded: classes.expPanelSummary
            }}
            expandIcon={<ExpandMoreIcon classes={{ root: classes.svg }} />}
          >
            <div onClick={this.stopSlider}>
              <Checkbox
                checked={this.state.visible}
                onChange={this.handleLayerVisabilityChange}
                classes={{
                  root: classes.checkbox,
                  checked: classes.colorChecked
                }}
                color="primary"
              />
            </div>
            <div className={classes.panelLabel}>
              <Typography classes={{ root: classes.layerLabel }}>
                {this.state.title}
              </Typography>

              {this.state.layer.infoButton && (
                <div className={classes.tooltip}>
                  <Typography classes={{ root: classes.tooltipText }}>
                    i
                  </Typography>
                  <div className={classes.tooltipInfo}>
                    <Typography classes={{ root: classes.tooltipInfoText }}>
                      {this.state.layer.infoButton}
                    </Typography>
                  </div>
                </div>
              )}
            </div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails
            classes={{ root: classes.expDetails }}
            onClick={this.stopSlider}
          >
            <div className={innerPanelStyles}>
              <div className={classes.content}>
                {this.state.symbology &&
                  Object.keys(this.state.symbology).length > 1 &&
                  this.generateLegend(this.state.symbology)}
              </div>

              <div className={classes.divider} />
              <div className={classes.actionButtons}>
                {this.state.layer.queryInfo && (
                  <div>
                    <Typography classes={{ root: classes.labelText }}>
                      Select Year
                    </Typography>
                    <YearSelector
                      min={this.state.layer.queryInfo.values.min}
                      max={this.state.layer.queryInfo.values.max}
                      layerId={this.props.layerId}
                    />
                  </div>
                )}
                <div
                  className={
                    this.state.type === 'map-image'
                      ? classes.hidden
                      : classes.opacityWrapper
                  }
                >
                  <Typography classes={{ root: classes.labelText }}>
                    Opacity
                  </Typography>
                  <Slider
                    min={0}
                    max={100}
                    step={1}
                    value={this.state.opacity}
                    onChange={this.handleOpacityChange}
                    classes={{
                      rail: classes.rail,
                      valueLabel: classes.valueLabel
                    }}
                    valueLabelDisplay="auto"
                    valueLabelFormat={`${this.state.opacity}%`}
                  />
                </div>
              </div>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(LayerExpPanel);
